import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { safeRedirectTarget } from '@/lib/safe-redirect';

export function VerifySuccessPage() {
  const { t } = useTranslation(['auth']);
  const [params] = useSearchParams();
  // Return a newly-verified user to the page they came from (protected-action
  // auth gate), falling back to the buyer dashboard. `safeRedirectTarget`
  // guards against open-redirect.
  const continueTarget = safeRedirectTarget(params.get('redirect'), '/dashboard');
  return (
    <section className="m5-shell">
      <div className="m5-icon-badge m5-icon-badge--success" aria-hidden="true">
        <svg
          width="32"
          height="32"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12.5 10 17l9-9.5" />
        </svg>
      </div>
      <h1 className="m5-shell__title">{t('auth:verify.successTitle')}</h1>
      <p className="m5-shell__lead">{t('auth:verify.successLead')}</p>

      <div className="m5-card">
        <Link to={continueTarget} className="m5-btn m5-btn--primary">
          {t('auth:verify.continue')}
        </Link>
      </div>
    </section>
  );
}
